import { createSlice } from '@reduxjs/toolkit';
import { ApiPaginationResponse } from 'src/components/ui/Table/Table.interface';
import {
  MANUFACTURER_ACCOUNT_SLICE,
  setManufacturerAccountDetails,
  setManufacturerAccountList,
  setManufacturerAccountStatus,
} from 'src/store/actions/manufacturerAccountActions';
import { ManufacturerAccount } from 'src/store/models/ManufacturerAccount';

export interface ManufacturerAccountState {
  manufacturerAccountList: ApiPaginationResponse<ManufacturerAccount[]>;
  manufacturerAccountDetails: ManufacturerAccount;
}

const initialState: ManufacturerAccountState = {
  manufacturerAccountList: {
    data: [],
    count: 0,
    ctx: null,
  },
  manufacturerAccountDetails: null,
};

const manufacturerAccountSlice = createSlice({
  name: MANUFACTURER_ACCOUNT_SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setManufacturerAccountList, (state, action) => {
        state.manufacturerAccountList = action.payload;
      })
      .addCase(setManufacturerAccountDetails, (state, action) => {
        state.manufacturerAccountDetails = action.payload;
      })
      .addCase(setManufacturerAccountStatus, (state, action) => {
        const manufacturer = state.manufacturerAccountList.data?.find(
          (s) => s.id === action.payload?.manufacturer?.id
        );
        if (manufacturer) {
          manufacturer.enabled = action.payload?.enabled;
        }
      });
  },
});

export default manufacturerAccountSlice.reducer;
